import { useLanguage, useSeo } from '../i18n/LanguageContext';
import { Eyebrow, MaskedLines, Reveal } from '../components/bits';

function LegalLayout({ eyebrow, title, updated, sections, pageId }) {
  return (
    <main>
      <section className="bg-ink pb-16 pt-44">
        <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
          <Eyebrow dark>{eyebrow}</Eyebrow>
          <MaskedLines
            as="h1"
            lines={[title]}
            delay={0.15}
            className="mt-6 font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl"
          />
          <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.25em] text-white/40">{updated}</p>
        </div>
      </section>
      <section className="noise-bg bg-cream py-16 md:py-24" data-testid={`${pageId}-content`}>
        <div className="mx-auto max-w-3xl px-6 sm:px-12">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={0.05} className={i === 0 ? '' : 'mt-12'}>
              <h2 className="font-display text-xl font-extrabold uppercase tracking-tight text-ink sm:text-2xl">
                {s.h}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-neutral-600">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}

export function Privacy() {
  const { t } = useLanguage();
  useSeo('privacy');
  const p = t.legal.privacy;
  return <LegalLayout eyebrow="DELUXE" title={p.title} updated={p.updated} sections={p.sections} pageId="privacy" />;
}

export function Terms() {
  const { t } = useLanguage();
  useSeo('terms');
  const p = t.legal.terms;
  return <LegalLayout eyebrow="DELUXE" title={p.title} updated={p.updated} sections={p.sections} pageId="terms" />;
}
